import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TranslatePipe } from '../translate.pipe';
import { LevelProgressDto } from '../types/LevelProgressDto';
import { LevelProgressBarDto } from './level-progress-bar-dto';

@Component({
  selector: 'lp2-level-progress-bar',
  templateUrl: './level-progress-bar.component.html',
  styleUrls: ['./level-progress-bar.component.scss'],
})
export class LevelProgressBarComponent implements OnChanges {
  @Input()
  progressData: LevelProgressDto;

  @Input()
  gamificationEnabled = false;

  levelText = '';
  progress: LevelProgressBarDto;
  levelCountArray: number[] = [];

  constructor(translatePipe: TranslatePipe) {
    this.levelText = translatePipe.transform('Level');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.progressData && changes.progressData.currentValue) {
      this.progress = this.parseProgressesResponse(this.progressData);
    }
  }

  getLevelLabelText(level: number) {
    return this.levelText + ' ' + level;
  }

  getLevelPercentage(level: number) {
    if (this.progress.levelNumber > level) {
      return 100;
    }
    if (this.progress.levelNumber < level) {
      return 0;
    }
    return this.progress.levelProgressPercent;
  }

  getIsCurrentLevel(level: number) {
    return this.progress.levelNumber === level;
  }

  private parseProgressesResponse(
    progresses: LevelProgressDto
  ): LevelProgressBarDto {
    if (!progresses) {
      return;
    }
    const response: LevelProgressBarDto = {
      levelNumber: +progresses.levelNumber,
      levelProgressPercent: +progresses.levelProgressPercent,
      totalLevelCount: +progresses.numLevels
    };
    this.levelCountArray = this.getTotalLevelCountArray(
      response.totalLevelCount
    );

    return response;
  }

  private getTotalLevelCountArray(count: number) {
    return Array.from(new Array(count), (val, index) => index + 1);
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/level-progress-bar/level-progress-bar.component.ts